import { createLogic } from 'redux-logic';
import { RECEIVED_ACTIVATED_FOR_TEXT_ALERTS } from 'state/alertsAndNotifications/AlertsAndNotificationsActions';
import { analyticsActionSuccess } from 'state/analytics/AnalyticsActions';
import { titleCase } from 'services/Formats';

const ActivatedForTextAlertsLogic = createLogic({
  type: [RECEIVED_ACTIVATED_FOR_TEXT_ALERTS],

  process({ action }, dispatch, done) {
    // dispatch analytics message
    const type = titleCase(action.type.slice('RECEIVED_'.length), '_', '');
    dispatch(analyticsActionSuccess('ProfPref', type));

    done();
  }
});

export default ActivatedForTextAlertsLogic;
